import React, { useMemo } from 'react'
import type { DocumentInsight } from '../../../../../services/projectAutofillDraftService.ts'
import styles from './DocumentInsightPanel.module.scss'

const KNOWN_ACTION_IDS = new Set([
  'upload_technical_doc',
  'continue_anyway',
  'contact_support'
])

const SUPPORT_MAIL = 'contacto@edify.la'

export type DocumentInsightPanelHandlers = {
  onUploadTechnicalDoc?: () => void
  onContinueAnyway?: () => void
}

type DocumentInsightPanelProps = {
  insight: DocumentInsight
  handlers?: DocumentInsightPanelHandlers
}

const DocumentInsightPanel: React.FC<DocumentInsightPanelProps> = ({ insight, handlers }) => {
  const title = useMemo(() => {
    const t = insight.titleForUser
    if (insight.confidence < 0.75) {
      const lower = t.charAt(0).toLowerCase() + t.slice(1)
      return `Podría ser que ${lower}`
    }
    return t
  }, [insight.confidence, insight.titleForUser])

  const wiredActions = useMemo(
    () => insight.suggestedActions.filter((a) => KNOWN_ACTION_IDS.has(a.id)),
    [insight.suggestedActions]
  )

  const onAction = (id: string) => {
    if (id === 'upload_technical_doc') {
      handlers?.onUploadTechnicalDoc?.()
      return
    }
    if (id === 'continue_anyway') {
      handlers?.onContinueAnyway?.()
      return
    }
    if (id === 'contact_support') {
      window.open(`mailto:${SUPPORT_MAIL}?subject=Consulta%20sobre%20documentaci%C3%B3n%20Edify`, '_blank')
    }
  }

  return (
    <div className={styles.wrap} role="region" aria-label="Clasificación del documento">
      <p className={styles.title}>{title}</p>
      {insight.bodyForUser ? <p className={styles.body}>{insight.bodyForUser}</p> : null}
      {wiredActions.length > 0 ? (
        <div className={styles.actions}>
          {wiredActions.map((a) => (
            <button
              key={`${a.id}-${a.label}`}
              type="button"
              className={styles.actionBtn}
              onClick={() => onAction(a.id)}
            >
              {a.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  )
}

export default DocumentInsightPanel
